<template>
  <div id="app">
    <nav-menu />
    <router-view />
    <scroll-to-top />
    <footer-menu />
  </div>
</template>

<script>
import NavMenu from './components/NavMenu.vue';
import FooterMenu from './components/FooterMenu.vue';
import ScrollToTop from './components/ScrollToTop.vue';

export default {
  name: 'App',
  components: {
    ScrollToTop,
    NavMenu,
    FooterMenu
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #212121;
  /* overflow-x: hidden; */
  /* margin-top: 60px; */
}



</style>
